import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";

export default function Audit() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/audit/log", { params: { limit: 200 } });
        setItems(data);
      } catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);

  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-black/60">{t("audit")}</div>
      <h1 className="font-display font-black text-5xl tracking-tighter leading-none mb-6">Audit log</h1>

      <div className="brut-border bg-white brut-shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F4F4F0] uppercase tracking-wider text-xs">
              <tr>
                <th className="text-left p-3 border-b-2 border-black">{t("time")}</th>
                <th className="text-left p-3 border-b-2 border-black">{t("action")}</th>
                <th className="text-left p-3 border-b-2 border-black">Actor</th>
                <th className="text-left p-3 border-b-2 border-black">IP</th>
                <th className="text-left p-3 border-b-2 border-black">Details</th>
              </tr>
            </thead>
            <tbody data-testid="audit-table">
              {items.map((a) => (
                <tr key={a.id} className="border-b border-black/10">
                  <td className="p-3 font-mono text-xs">{new Date(a.timestamp).toLocaleString()}</td>
                  <td className="p-3"><span className="tag bg-[#FFCC00]">{a.action}</span></td>
                  <td className="p-3 text-xs">{a.actor_email || "—"}</td>
                  <td className="p-3 font-mono text-xs">{a.ip || "—"}</td>
                  <td className="p-3 font-mono text-xs max-w-md truncate">{JSON.stringify(a.details || {})}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={5} className="p-6 text-center text-black/60">{t("no_data")}</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
